import { IPurchaseOptions } from "@/types";

const findPurchasePlanName = (purchaseOptions: IPurchaseOptions | null, planId: string | null | undefined): string | undefined => {
  if (!planId || !purchaseOptions) {
    return undefined;
  }
  const allPlans = [...purchaseOptions.monthly_plans, ...(purchaseOptions.quarterly_plans ?? []), ...purchaseOptions.annual_plans];
  return allPlans.find((purchasePlan) => purchasePlan.plan_id === planId)?.name;
};

export default findPurchasePlanName;
